/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {SIGN_IN, SIGN_OUT, LOAD_USER_PROFILE, REQUEST_USER_PROFILE, ACCEPT_DISCLAIMER} from './SecurityReducer'
import {
    exchangeAccessCode as secExchangeAccessCode,
    authenticateUniqueSession as secAuthenticateUniqueSession,
    signIn as secSignIn,
    signOut as secSignOut,
    loadUserProfile as secLoadUserProfile
} from '../api/Security'

export const exchangeAccessCode = (accessCode) => dispatch => {
    dispatch(requestUserProfile())
    return secExchangeAccessCode(accessCode)
        .then(userProfile => {
            return processUserProfile(dispatch, userProfile)
        }).catch(error => {
            dispatch({type: SIGN_IN, userProfile: null})
            throw error
        })
}

export const authenticateUniqueSession = (sessionId) => dispatch => {
    dispatch(requestUserProfile())
    return secAuthenticateUniqueSession(sessionId)
        .then(userProfile => {
            return processUserProfile(dispatch, userProfile)
        }).catch(error => {
            dispatch({type: SIGN_IN, userProfile: null})
            throw error
        })
}

export const signIn = (username, password) => dispatch => {
    dispatch(requestUserProfile())
    return secSignIn(username, password)
        .then(userProfile => {
            return processUserProfile(dispatch, userProfile)
        }).catch(error => {
            dispatch({type: SIGN_IN, userProfile: null})
            throw error
        })
}

export const signOut = () => {
    secSignOut()
    return {type: SIGN_OUT}
}

export const loadUserProfile = () => dispatch => {
    dispatch(requestUserProfile())
    return secLoadUserProfile()
        .then(userProfile => {
            if (!userProfile) {
                dispatch({type: LOAD_USER_PROFILE, userProfile: null})
                return null
            } else {
                dispatch({type: LOAD_USER_PROFILE, userProfile})
                return userProfile
            }
        }).catch(error => {
            dispatch({type: LOAD_USER_PROFILE, userProfile: null})
            throw error
        })
}


const requestUserProfile = () => {
    return {
        type: REQUEST_USER_PROFILE,
    }
}

export const acceptDisclaimer = () => dispatch => {
    dispatch({type: ACCEPT_DISCLAIMER})
}

const processUserProfile = (dispatch, userProfile) => {
    if (!userProfile) {
        dispatch({type: SIGN_IN, userProfile: null})
        return null
    } else {
        dispatch({type: SIGN_IN, userProfile})
        return userProfile
    }
}